export default __webpack_public_path__ + "static/media/AICTE.a0b0f2e6.jpg";